import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useMediaQuery} from 'react-responsive';
import {Link, useHistory} from 'react-router-dom';
import {compose} from 'redux';
import * as Yup from 'yup';
import {get} from '../../../../../api/api';
import {
  getAppointmentSpecialities,
  getAppointmentSpecialitiesBO,
  uriGetBus,
  uriGetSpecialties,
  uriUserBuOnlineOnly,
  uriUserBuV2,
} from '../../../../../api/endpoints';
import {ITenant} from '../../../../../App';
import AppButton from '../../../../../components/app-button';
import AppSpinner from '../../../../../components/app-spinner';
import {AppForm, AppFormSubmitButton} from '../../../../../components/forms';
import Icon from '../../../../../components/icon';
import AppSelectInput from '../../../../../components/input/app-select-input';
import {Column, Row} from '../../../../../components/layout';
import ModalTemplate from '../../../../../components/modal';
import {getBuFunctionalities} from '../../../../../graphQL';
import {
  addToWizard,
  setSelectedBu,
  setWizard,
  setUpdateRoutesNewSelectedPatient,
} from '../../../../../store/actions';
import colors from '../../../../../util/colors';
import * as fonts from '../../../../../util/fonts';
import {Icons} from '../../../../../util/icons';
import {functionalitiesAliasMap, strings} from '../../../../../util/strings';
import {
  ApiResponseArray,
  capitalizeName,
  getColor,
} from '../../../../../util/utility';
import AppointmentsScheduleCapPopup from '../../../../appointments/components/appointments-schedule-cap-popup/AppointmentsScheduleCapPopup';
import './styles.scss';

interface NewPatientValidationProps {
  selectedBu: any;
  labels: typeof strings.pt.appointments;
  labelsRefund: typeof strings.pt.refund;
  labelsCreateRefund: typeof strings.pt.createRefund;
  labelsPreAuthorizations: typeof strings.pt.preAuthorizations;
  labelsMessages: typeof strings.pt.messages;
  user: any;
  busMap: any;
  setSelectedBu(value: any): void;
  nextStep(): void;
  onSubmit(values: any): any;
  addToWizard(value: any): void;
  setWizard(value: any): void;
  setUpdateRoutesNewSelectedPatient(): void;
  hideExit?: boolean;
  functionalityAtiva?: string;
  validationMethod?: Function;
  busGroupExceptions: any;
  busProductExceptions: any;
  busFunctionalities: any;
  currentTitular?: any;
  specificErrorMessage?: any;
  busFuncMap: any;
  tenant: ITenant;
  language: string;
  bankAccountDataHolder: any;
}

enum Bu {
  notClient = 'NOTCLIENT',
}

const validationSchema = Yup.object().shape({});

function NewPatientValidation({
  selectedBu,
  labels,
  labelsRefund,
  labelsCreateRefund,
  labelsPreAuthorizations,
  labelsMessages,
  user,
  busMap,
  setWizard,
  setUpdateRoutesNewSelectedPatient,
  nextStep,
  setSelectedBu,
  addToWizard,
  hideExit,
  validationMethod,
  functionalityAtiva,
  busGroupExceptions,
  busProductExceptions,
  busFunctionalities,
  currentTitular,
  specificErrorMessage,
  busFuncMap,
  tenant,
  language,
  bankAccountDataHolder,
}: NewPatientValidationProps) {
  const [valid, setValid] = useState(false);
  const [buOptionsMap, setBuOptionsMap]: any = useState({});
  const [patientGroupOptions, setPatientGroupOptions]: any[] = useState([]);
  const [patientOptions, setPatientOptions]: any[] = useState([]);
  const [buNames, setBuNames]: any[] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [patientGroupValue, setPatientGroupValue]: any = useState('');
  const [patientGroupValueMask, setPatientGroupValueMask]: any = useState({});
  const [patientValue, setPatientValue]: any = useState('');
  const [patientValueMask, setPatientValueMask]: any = useState('');
  const [patientListInfo, setPatientListInfo]: any = useState([]);
  const [buToChange, setBuToChange] = useState({});
  const [showError, setShowError] = useState(false);
  const [showGeneralError, setShowGeneralError] = useState(false);
  const [specialities, setSpecialities]: any[] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showAppointmentCapError, setShowAppointmentCapError] = useState(false);
  const [patientList, setPatientList]: any = useState([]);
  const [showModalIban, setShowModalIban] = useState(false);

  const isResponsive = useMediaQuery({maxDeviceWidth: 768});

  const history = useHistory();

  const getPatientList = async () => {
    const uriUserBu =
      functionalityAtiva === 'consulta-online'
        ? uriUserBuOnlineOnly(user.nif, user.birthdate, true)
        : uriUserBuV2(user.nif, user.birthdate);
    try {
      await get(uriUserBu).then((res: any) => {
        if (res) {
          setPatientList(res?.data?.products);
        }
      });
    } catch {
      if (functionalityAtiva === 'consulta-online') {
        setShowError(true);
      } else {
        setShowGeneralError(true);
      }
    }
  };

  const busNames = async () => {
    await get(uriGetBus())
      .then((response: ApiResponseArray | unknown) => {
        const res = response as ApiResponseArray;
        console.log('response', response);

        setBuNames(
          res?.data?.items?.map((bu: any) => ({
            value: bu.id,
            label: bu.name,
          }))
        );
      })
      .catch((err: any) => {
        console.log('err', err);
      })
      .finally(() => {
        setLoaded(true);
      });
  };

  useEffect(() => {
    busNames();
    getPatientList();
  }, []);

  const updateOptions = () => {
    const optionsMap: any = {};
    patientList.map((el: any) => {
      if (optionsMap[el.famId]) {
        return optionsMap[el.famId].push(el);
      } else {
        return (optionsMap[el.famId] = [el]);
      }
    });
    setBuOptionsMap(optionsMap);

    const patientGroups = Object.keys(optionsMap).map((el: any) => {
      const aux = optionsMap[el][0].buId;
      const bu = buNames.find((el: any) => el.value === aux);
      const loggedPerson = optionsMap[el].find(
        (card: any) => card.nif === user.nif
      );

      return loggedPerson
        ? {
            label: `${bu?.label} - ${
              loggedPerson.usesMulticode === 1
                ? `${loggedPerson.multicode}`
                : `${loggedPerson.memId}`
            }`,
          }
        : {
            label: `${bu?.label} - ${
              optionsMap[el][0].usesMulticode === 1
                ? `${optionsMap[el][0].multicode}`
                : `${optionsMap[el][0].memId}`
            }`,
          };
    });
    setPatientGroupOptions(patientGroups);

    //logic for the default value of the patient groups dropdown

    let foundFlag = false; //if flag isnt changed, it means the the group selected isn't the same as the selected user group

    //search for the patient group of the selected user
    patientGroups.map((p: any) => {
      const selectedGroup = optionsMap[selectedBu.famId]?.find((el: any) =>
        el.usesMulticode === 1
          ? p?.label.includes(el.multicode.toString())
          : p?.label.includes(el.memId.toString())
      );
      if (selectedGroup) {
        setPatientGroupValue(p?.label);
        foundFlag = true;
        if (p?.label?.split('-').length > 2) {
          let tokens = p?.label?.split('-');
          let aux = tokens.slice(0, -1).join('-');
          setPatientGroupValueMask({
            bu: aux,
            code: tokens[tokens.length - 1],
          });
        } else {
          setPatientGroupValueMask({
            bu: p?.label?.split('-')[0],
            code: p?.label?.split('-')[1],
          });
        }
      }
    });

    //if it didnt find the selected user, then it shall use the first element as the default value of the dropdown
    if (!foundFlag) {
      setPatientGroupValue(patientGroups[0]);
      setPatientGroupValueMask({
        bu: patientGroups[0]?.label?.split('-')[0],
        code: patientGroups[0]?.label?.split('-')[1],
      });
    }
    ////////
    // logic to load the patients for the default group
    generatePatientOptions(
      selectedBu.usesMulticode ? selectedBu.multicode : selectedBu.memId,
      optionsMap
    );
    ////////
  };

  useEffect(() => {
    if (loaded) {
      updateOptions();
    }
  }, [loaded, patientList]);

  const generatePatientOptions = (code: any, options: any) => {
    let patients: any = [];
    var firstOption: any = [];
    Object.keys(options).map((el: any, index: any) => {
      if (index === 0) {
        firstOption = options[el];
      }
      const aux = options[el].find(
        (a: any) =>
          // trims empty spaces
          a.memId === code.replace(/ /g, '') ||
          a.multicode === code.replace(/ /g, '')
      );
      if (aux) {
        patients = options[el];
      }
    });

    if (patients.length === 0 && firstOption.length > 0) {
      patients = firstOption;
    }

    const patientLabels = patients.map((el: any) => {
      return {
        label: `${capitalizeName(el.memberName)} - ${
          el.usesMulticode === 1 ? el.multicode : el.memId
        }`,
      };
    });

    setPatientOptions(patientLabels);

    const selectedPatient = patientLabels.find((el: any) =>
      selectedBu.usesMulticode === 1
        ? el?.label.includes(selectedBu.multicode.toString())
        : el?.label.includes(selectedBu.memId.toString())
    );

    setPatientValue(
      selectedPatient ? selectedPatient?.label : patientLabels[0]
    );

    const parts =
      selectedPatient?.label?.split(' - ') ||
      patientLabels?.label?.split(' - ');
    if (!!parts) {
      const [firstPart, ...rest] = parts;
      const secondPart = rest.pop();
      const combinedFirstPart = [firstPart, ...rest].join(' - ');

      setPatientValueMask({
        name: combinedFirstPart,
        code: secondPart,
      });
    }
    setPatientListInfo(patients);
  };

  const handleGroupChange = (value: any) => {
    const newBu = value?.split('-')[0];
    const newCode = value?.split('-')[1];
    setPatientGroupValue(value);
    setPatientGroupValueMask({
      bu: newBu,
      code: newCode,
    });

    //Search for the patients of that group (right dropdown)
    generatePatientOptions(newCode, buOptionsMap);
  };

  const handlePatientChange = (value: any) => {
    setPatientValue(value);
    const parts = value?.split(' - ');
    const [firstPart, ...rest] = parts;
    const secondPart = rest.pop();
    const combinedFirstPart = [firstPart, ...rest].join(' - ');

    setPatientValueMask({
      name: combinedFirstPart,
      code: secondPart,
    });
  };

  const getSpecialities = async (patientSelected: any) => {
    try {
      let resultToFormat: any = {};
      if (user.state === 'NOTCLIENT') {
        resultToFormat = await get(getAppointmentSpecialitiesBO());
        resultToFormat = resultToFormat?.data?.items?.filter(
          (spec: any) => spec.showToAll && spec.status === 'ACTIVE'
        );
      } else {
        resultToFormat = await get(
          getAppointmentSpecialities(selectedBu.buId, selectedBu.benNbr)
        );
      }
      const specialityOptions = resultToFormat.map((el: any) => {
        const integratorSpecialty = el.integratorSpecialty;
        const priceCalculation = el.priceCalculation;

        const sp = el.specialtyDetails.find(
          (detail: any) => detail.languageAlias === language
        );
        if (sp) {
          return {
            ...sp,
            integratorSpecialty: integratorSpecialty,
            priceCalculation: priceCalculation,
          };
        }
      });
      const patientInsurance = {
        patient: patientSelected,
        specialities: specialityOptions,
      };
      addToWizard({patientInsurance});
      nextStep();
      setUpdateRoutesNewSelectedPatient();
      // window.location.reload();
    } catch (err: any) {
      setShowGeneralError(true);
    }
  };

  const checkExceptionFunctionalities = async () => {
    const patientSelected = patientListInfo.find(
      (el: any) =>
        el.multicode === patientValueMask.code ||
        el.memId === patientValueMask.code
    );

    let exceptionRule: any = [];

    const groupsMap = busGroupExceptions?.filter(
      (exception: any) => exception.buAlias === patientSelected.buId
    );

    exceptionRule =
      groupsMap?.filter((item: any) => item.groupId == patientSelected.grpId) ||
      [];
    const inactiveFunctionalities = exceptionRule;

    const productsMap = busProductExceptions?.filter(
      (exception: any) => exception.buAlias === patientSelected.buId
    );
    exceptionRule =
      productsMap?.filter(
        (prod: any) => prod.productAlias === patientSelected.prdNbr
      ) || [];

    const moreInactiveFunctionalities = exceptionRule;

    var inactiveFunctionality = false;

    const inactiveForGroup = inactiveFunctionalities.length > 0;
    const inactiveForPrd = moreInactiveFunctionalities.length > 0;

    var inactiveFuncs: any[] = [];
    if (inactiveForGroup) {
      inactiveFuncs = [...inactiveFunctionalities[0]?.inactiveFeatures];
    }
    if (inactiveForPrd) {
      inactiveFuncs.push({
        ...moreInactiveFunctionalities[0]?.inactiveFeatures,
      });
    }
    const flattenedArray = inactiveFuncs.flatMap(Object.values);

    const inativeFunc = flattenedArray.some((product: any) =>
      product?.includes(functionalityAtiva)
    );
    if (inativeFunc) {
      inactiveFunctionality = true;
    }

    if (inactiveFunctionality) {
      if (functionalityAtiva === 'consulta-online') {
        setShowError(true);
      } else {
        setShowGeneralError(true);
      }
    } else {
      Object.keys(busMap[patientSelected.buId]).map((el: any) => {
        const found = busMap[patientSelected.buId][el].find(
          (a: any) =>
            a.memId === patientValueMask.code ||
            a.multicode === patientValueMask.code
        );
        if (found) {
          setBuToChange(found);
          setSelectedBu(found);
        }
      });

      if (functionalityAtiva === 'consulta-online') {
        //get specialities to determine if shows error still in step2 ou not
        getSpecialities(patientSelected);
      } else {
        nextStep();
        setUpdateRoutesNewSelectedPatient();
        // window.location.reload();
      }
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    let canProceed = false;
    const patientSelected = patientListInfo.find(
      (el: any) =>
        el.multicode === patientValueMask.code ||
        el.memId === patientValueMask.code
    );

    const buFunctionalities = busFuncMap?.[patientSelected.buId];

    const funcionalidadeAtiva = buFunctionalities?.find(
      (el: any) => el.featureTemplateAlias === functionalityAtiva
    );

    canProceed = validationMethod && (await validationMethod(patientSelected));

    if (canProceed) {
      if (funcionalidadeAtiva?.isVisible) {
        //avança
        checkExceptionFunctionalities();
      } else {
        if (functionalityAtiva === 'consulta-online') {
          setShowError(true);
        } else {
          setShowGeneralError(true);
        }
      }
    } else {
      switch (functionalityAtiva) {
        case 'consulta-online': {
          setShowAppointmentCapError(true);
          break;
        }
        case functionalitiesAliasMap.createRefund: {
          setShowModalIban(true);
          break;
        }
        case functionalitiesAliasMap.authorization: {
          setShowGeneralError(true);
          break;
        }
      }
    }
    setIsLoading(false);
  };

  const handleOnOkClick = () => {
    // const patientSelected = patientListInfo.find(
    //   (el: any) =>
    //     el.multicode === patientValueMask.code ||
    //     el.memId === patientValueMask.code
    // );
    // Object.keys(busMap[patientSelected.buId]).map((el: any) => {
    //   const found = busMap[patientSelected.buId][el].find(
    //     (a: any) =>
    //       a.memId === patientValueMask.code ||
    //       a.multicode === patientValueMask.code
    //   );
    //   if (found) {
    //     setBuToChange(found);
    //     setSelectedBu(found);
    //   }
    // });
    setShowModalIban(false);
  };

  const defineIbanModal = () => {
    const patientSelected = patientListInfo?.find(
      (el: any) =>
        el.multicode === patientValueMask.code ||
        el.memId === patientValueMask.code
    );
    const isTitular =
      bankAccountDataHolder === 'SUBSCRIBER'
        ? currentTitular?.memId === patientSelected?.memId &&
          currentTitular?.buId === patientSelected?.buId
        : true;
    let isAtiva = {activa: false};
    if (patientSelected) {
      isAtiva = busFuncMap[patientSelected?.buId].find(
        (el: any) => el.featureTemplateAlias === functionalityAtiva
      );
    }
    return (
      <ModalTemplate
        type="error"
        inputType="confirm"
        show={showModalIban}
        onHide={() => setShowModalIban(false)}
        cross={false}
        hideFooter>
        <Column>
          <div
            style={{
              ...fonts.M,
              ...fonts.Bold,
              ...getColor('color', colors.alertRed),
            }}>
            {specificErrorMessage
              ? specificErrorMessage
              : isAtiva?.activa
              ? isTitular
                ? labelsRefund?.refundHistory_ibanError
                : labelsRefund?.refundHistory_ibanError_not_titular
              : labelsCreateRefund?.refund_inactive_functionality}
          </div>
        </Column>
        <AppButton
          onClick={() => {
            labels?.appointments_understood && isTitular
              ? handleOnOkClick()
              : setShowModalIban(false);
          }}
          className="button-iban-modal">
          {isAtiva?.activa && isTitular
            ? labelsRefund?.refundHistory_defineIban
            : labels?.appointments_understood}
        </AppButton>
      </ModalTemplate>
    );
  };

  const renderStep = () => {
    patientList?.length === 1 && nextStep();
    return (
      <AppForm
        initialValues={{cardNumber: ''}}
        validationSchema={validationSchema}
        onSubmit={() => handleSubmit()}
        onValidation={(valid) => setValid(valid)}>
        {!isResponsive && (
          <Column className="patient-select-box-column">
            <Row className="patient-select-dropdown-row">
              <Column className="label-mask" style={{...fonts.M}}>
                <div
                  style={getColor('color')}
                  className="patient-group-bu-name">
                  {patientGroupValueMask?.bu}
                </div>
                <div>{patientGroupValueMask?.code}</div>
              </Column>
              <AppSelectInput
                disabled
                customIcon="none"
                className="patient-group-input"
                options={patientGroupOptions}
                value={patientGroupValue}
                onChange={(value: any) => {
                  handleGroupChange(value);
                }}
              />
              <div className="separator"></div>
              <Column className="label-mask-two" style={{...fonts.M}}>
                <div
                  style={getColor('color')}
                  className="patient-group-bu-name">
                  {patientValueMask?.name}
                </div>
                <div>{patientValueMask?.code}</div>
              </Column>
              <AppSelectInput
                className="patient-input"
                options={patientOptions}
                value={patientValue}
                onChange={(value) => {
                  handlePatientChange(value);
                }}
              />
            </Row>
          </Column>
        )}
        {isResponsive && (
          <>
            <Column className="patient-select-box-column">
              <Row className="patient-select-dropdown-row">
                <Column className="label-mask" style={{...fonts.M}}>
                  <div
                    style={getColor('color')}
                    className="patient-group-bu-name">
                    {patientGroupValueMask?.bu}
                  </div>
                  <div>{patientGroupValueMask?.code}</div>
                </Column>
                <AppSelectInput
                  className="patient-group-input"
                  options={patientGroupOptions}
                  value={patientGroupValue}
                  onChange={(value: any) => {
                    handleGroupChange(value);
                  }}
                />
              </Row>
              <Row className="patient-select-dropdown-row-two">
                <Column className="label-mask-two" style={{...fonts.M}}>
                  <div
                    style={getColor('color')}
                    className="patient-group-bu-name">
                    {patientValueMask?.name}
                  </div>
                  <div>{patientValueMask?.code}</div>
                </Column>
                <AppSelectInput
                  className="patient-input"
                  options={patientOptions}
                  value={patientValue}
                  onChange={(value) => {
                    handlePatientChange(value);
                  }}
                />
              </Row>
            </Column>
          </>
        )}
        <AppFormSubmitButton
          title={labels?.appointments_detail_confirm}
          disabled={isLoading}
          type="submit"
          className="patient-submit-button"
        />
        {isResponsive && !hideExit && (
          <Row className="exit-button-responsive">
            <Link
              onClick={async () => {
                setWizard({});
              }}
              to="/consultas-online"
              className="appointments-schedule-header-content-exit-label"
              style={{
                ...fonts.SM,
                ...fonts.SemiBold,
                ...getColor('color'),
              }}>
              {labels?.appointments_schedule_leave}
              <Icon
                className="reimbursement-header-content-close-icon svg-close-button inline-svg-close-button"
                name={Icons.CLOSE}
                width={'12'}
                height={'12'}
                changeViewbox={true}
                strokeWidth={'0.5'}
              />
            </Link>
          </Row>
        )}
      </AppForm>
    );
  };

  const generateErrorMessage = () => {
    var errorMessage = '';

    switch (functionalityAtiva) {
      case 'consultas-online': {
        errorMessage = labels?.appointments_choosePatiente_error;
        break;
      }
      case 'pedir-reembolso': {
        errorMessage = labelsCreateRefund?.refund_inactive_functionality;
        break;
      }
      case 'pre-autorizacoes': {
        errorMessage =
          labelsPreAuthorizations?.authorization_inactive_functionality;
        break;
      }
      default:
        errorMessage = labels?.appointments_error;
    }

    return errorMessage;
  };

  return (
    <>
      <Row className="patient-select-title-row">
        <p className="patient-select-title" style={{...fonts.ML}}>
          {labels?.appointments_schedulo_step1_title}
        </p>
      </Row>

      {patientList?.length > 0 ? (
        renderStep()
      ) : (
        <Row className="stepper-spinner-row">
          <AppSpinner className="stepper-spinner" />
        </Row>
      )}

      <AppointmentsScheduleCapPopup
        show={showAppointmentCapError}
        setShowModal={setShowAppointmentCapError}
      />
      {defineIbanModal()}

      <ModalTemplate
        className="appointment-cancel-container"
        contentClassName="appointment-cancel-content"
        show={showError || showGeneralError}
        onHide={() => {
          showError ? setShowError(false) : setShowGeneralError(false);
        }}
        cross={true}
        hideFooter={true}
        size="sm">
        <div className="modal-error-container">
          <Row className="my-profile-submit-button-row">
            <Icon
              name={Icons.ALERT_PROBLEM}
              width={'40'}
              height={'40'}
              color={colors.alertRed}
              changeViewbox
              viewBox={'0 0 24 24'}
            />
          </Row>
          <Row className="errorPopup-title-row">
            <p
              style={{
                ...fonts.MM,
                ...fonts.Bold,
                ...getColor('color', colors.alertRed),
              }}
              className="p-errorPopup">
              {showError && labels?.appointments_choosePatiente_error}
              {showGeneralError && generateErrorMessage()}
            </p>
          </Row>
          <Row className="my-profile-submit-button-row">
            <AppButton
              title="Ok"
              variant="primary"
              onClick={() => {
                showError ? setShowError(false) : setShowGeneralError(false);
              }}>
              Ok
            </AppButton>
          </Row>
        </div>
      </ModalTemplate>
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  stringsDefault,
  busMap,
  busFuncMap,
  busGroupExceptions,
  busProductExceptions,
  busFunctionalities,
  tenant,
  language,
  bankAccountDataHolder,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.appointments,
  busMap: busMap.value,
  busFuncMap: busFuncMap.value,
  labelsRefund: strings.value.pt.refund,
  labelsCreateRefund: strings.value.pt.createRefund,
  labelsPreAuthorizations: strings.value.pt.preAuthorizations,
  busGroupExceptions: busGroupExceptions.value,
  busProductExceptions: busProductExceptions.value,
  labelsMessages: stringsDefault.value.pt.messages,
  busFunctionalities: busFunctionalities.value,
  tenant: tenant.value,
  language: language.value,
  bankAccountDataHolder: bankAccountDataHolder.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setSelectedBu: (value: any) => dispatch(setSelectedBu(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
  setUpdateRoutesNewSelectedPatient: () =>
    dispatch(setUpdateRoutesNewSelectedPatient()),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(NewPatientValidation)
);
